import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logPageView } from "../../utils/analytics";
import { trackUserPage } from "../../services/UserTrackerService";

const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    logPageView(location.pathname + location.search);

    // Track user page visit (non-blocking)
    trackUserPage({
      page: location.pathname,
      service: null,
      reference: location.search || null,
    });
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleAnalyticsTracker;
